<template>
  <div class="app-container">
    <transition name="fade-transform" mode="out-in">
      <keep-alive include="MemberList">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </div>
</template>
<script>
export default {
  computed: {
    key() {
      return this.$route.path;
    },
    cachedViews() {
      return this.$store.state.layout.cachedViews;
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  overflow: hidden;
  padding: 32px;
  min-height: calc(100% - 84px);
  width: 100%;
  background-color: #f0f2f5;

  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all 0.5s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
}
</style>